module.exports = __webpack_public_path__ + "img/correo.3ad7613b.svg";